export default __webpack_public_path__ + "static/media/check.ae308ac7.svg";